export const environment = {
  environmentName: 'Development',
  webAPIRoots: {
    /*DEV*/
    core: 'https://localhost:7232',
  },
  assetsFolderPath: 'assets/',
  isEmbedMode: true,
  showBreadcrumb: true,
  appInsights: {
    instrumentationKey: '076bf778-c330-4b39-9c11-0e5f67601535',
  },
  allowAppInsightLog: false,
  gtm: 'GTM-W4S4Z7V3',
  pdfConcurrency: {
    downloads: 5,
    thumbnails: 3,
  },
};
